module.exports = __webpack_public_path__ + "media/images/hero/glyph-b2-fdef4250e96397e9aa8d0757cc305833.svg";